import * as getters from '@/store/modules/payments/requests/baiPaga/getters'
import * as mutations from '@/store/modules/payments/requests/baiPaga/mutations'
import * as actions from '@/store/modules/payments/requests/baiPaga/actions'

const state = {
  accountsBalances: [],
  paymentsRequestsStatusList: [],
  paymentsRequestsList: [],
  paymentsDetail: [],
  paymentsRequestsHasMore: false
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
